@let value = $_value() !== undefined ? $_value() : $controlValue();
@let disabled = $disabled() !== undefined ? $disabled() : $controlDisabled();
@let controlPosition = $controlPosition();
@let verticalAlignment = $verticalAlignment() === 'center' ? 'items-center' : $verticalAlignment() === 'start' ? 'items-start' : 'items-end';
<label
  [class]="'flex' + (controlPosition === 'default' || controlPosition === 'opposite' ? ' items-center' : ' flex-col ' + verticalAlignment)"
  [style.padding]="$innerPadding() | cssValue"
  [style.gap]="$gap() | cssValue"
  [class.disab]="disabled"
  [class.readonly]="$readonly()"
  [matTooltip]="!disabled ? $tooltip() : $tooltipWhenDisabled()"
>
  <input
    type="checkbox"
    [disabled]="disabled || $readonly()"
    [checked]="value"
    [class]="controlPosition === 'default' || controlPosition === 'top' ? 'order-0' : 'order-1'"
    (change)="onValueChange($event)"
  >
  @if ($label() !== null) {
  <p
    [class]="$labelWrap() ? '' : 'whitespace-nowrap'" 
    [style.fontSize]="$labelFontSize() | cssValue"
    [style.fontWeight]="$labelWeight()"
    [style.color]="'var(' + $labelColor() + ')'"
  >{{ $label() }}</p>
  }
</label>
